const FIREFOX = 'Firefox';
const OPERA = 'Opera';
const IE = 'Internet Explorer';
const EDGE = 'Edge';
const CHROME = 'Chrome';
const SAFARI = 'Safari';

const checkBrowser = () => {
    const userAgent = navigator.userAgent;
    let browser = null;

    // the order of checks is important, userAgent usually contains more then one browser name
    if (userAgent.indexOf(FIREFOX) > -1 || !!window.mozInnerScreenX) {
        browser = FIREFOX;
    }
    else if (userAgent.indexOf(OPERA) > -1 || userAgent.indexOf('OPR') > -1) {
        browser = OPERA;
    }
    else if (userAgent.indexOf('Trident') > -1) {
        browser = IE;
    }
    else if (userAgent.indexOf(EDGE) > -1) {
        browser = EDGE;
    }
    else if (userAgent.indexOf(CHROME) > -1) {
        browser = CHROME;
    }
    else if (userAgent.indexOf(SAFARI) > -1) {
        browser = SAFARI;
    }

    return browser;
};

export const isSafari = () => {
    return checkBrowser() === SAFARI;
};

export const isIE = () => {
    return checkBrowser() === IE;
};
